export function neverError(message: string, token: never): Error {
  return new Error(`${message}. ${token} should not exist`);
}
